import Web3DView from './page/main/Web3DView'
import Vue from 'vue';
import axios from 'axios';
import ElementUI from 'element-ui';
import $ from 'jquery';
// import '../../static/bimroad/fonts/iconfont.css';

let Web3DViewPlugin = {}
Web3DViewPlugin.install = function (Vue, options) {
  Vue.component(Web3DView.name, Web3DView) // testPanel.name 组件的name属性
	  Vue.use(ElementUI);

	Vue.prototype.axios = axios;

}
export default Web3DViewPlugin



// WEBPACK FOOTER //
// ./src/plugins/index.js